import React, { useState } from "react";
import { Route, Routes, Link, BrowserRouter } from "react-router-dom";

import MobileHomepage from "../Screens/homePage";

import AboutClassplus from "../Screens/aboutClassplus";
import ContactUs from "../Screens/contactUs";

import AboutAnant from "../Screens/aboutAnant";

import NavBar from "../components/navBar";
import BottomSheet from "../components/bottomSheet";

const MobileView = () => {
  return (
    <div className="mobile-view">
      <BrowserRouter basename="/Finclave2022">
        <NavBar />
        <Routes>
          <Route path="/" element={<MobileHomepage />} />

          <Route path="/aboutClp" element={<AboutClassplus />} />

          <Route path="/aboutAnant" element={<AboutAnant />} />

          <Route path="/contactUs" element={<ContactUs />} />
        </Routes>
        <BottomSheet />
      </BrowserRouter>
    </div>
  );
};

export default MobileView;
